import { mixins } from 'vue-class-component'
import { Component } from 'vue-property-decorator'

import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue'
import AppSimpleButton from '@/components/AppSimpleButton.vue'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { utcDateTimeToLocal } from '@/utils/dateTime'
import SchoolDialog from '../SchoolList/script-dialog'

@Component({
  components: {
    AppBreadcrumbs,
    AppRefreshAndExport,
    AppDialog,
    AppSimpleButton
  }
})

export default class SchoolDetail extends mixins(SchoolDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: '学校管理'
    },
    {
      text: '学校',
      to: { name: 'SchoolList' }
    }

  ]

  disableConfirm = false

  windowSize = {
    w: 0,
    h: 0
  }

  actionsHeight = 51

  loading = false
  dealers: any = []
  headers = [
    { text: '姓名', value: 'realname', sortable: false },
    { text: '手机号', value: 'user.phone', sortable: false },
    { text: '店铺名称', value: 'storeName', sortable: false },
    { text: '店铺电话', value: 'storePhone', sortable: false }
  ]

  options = {
    sortBy: ['realname'],
    sortDesc: [true]
  }

  schoolId = ''
  utcDateTimeToLocal = utcDateTimeToLocal

  async mounted () {
    this.onResize()
    // 缓存数据
    const { id } = this.$route.params
    this.schoolId = id
    this.targetSchool = await this.getSchoolById(Number(this.schoolId))
    this.dealers = this.targetSchool?.dealers
    this.breadcrumbs.push({ text: `${this.targetSchool?.name}` })
  }

  async deleteConfirm () {
    await this.deleteSchoolById()
    this.$router.push({
      name: 'SchoolList'
    })
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }

  // 导出
  exportHandler () {
    // todo
  }
}
